import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    controlledSoftwareCount: { default: 0 },
    interceptionCount30Days: { default: 0 },
    activePolicyCount: { default: 0 },
    involvedTerminalCount: { default: 0 }
  },
  setup(__props: any) {

const { t, locale } = useI18n()

const props = __props

const statisticsItems = computed(() => {
  void locale.value
  return [
    { label: t('softwareDisabledCharts.statControlledSoftware'), value: props.controlledSoftwareCount, span: 6 },
    { label: t('softwareDisabledCharts.statInterceptions30d'), value: props.interceptionCount30Days, span: 6 },
    { label: t('softwareDisabledCharts.statActivePolicies'), value: props.activePolicyCount, span: 6 },
    { label: t('softwareDisabledCharts.statInvolvedTerminals'), value: props.involvedTerminalCount, span: 6 },
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})